import { useState, useEffect } from "react";
import { Calendar } from "lucide-react";
import { fmtDate, usToIso } from "@/lib/dates";

const mask = (raw) => {
  const d = raw.replace(/\D/g, "").slice(0, 8);
  if (d.length <= 2) return d;
  if (d.length <= 4) return `${d.slice(0, 2)}/${d.slice(2)}`;
  return `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}`;
};

// Text date field shown as MM/DD/YYYY; value/onChange use "YYYY-MM-DD" like a native date input.
export function DateInput({ value, onChange, "data-testid": testId, placeholder = "MM/DD/YYYY" }) {
  const [text, setText] = useState(fmtDate(value));

  useEffect(() => {
    if ((usToIso(text) || "") !== (value || "")) setText(fmtDate(value));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const emit = (iso) => onChange?.({ target: { value: iso } });

  const onType = (e) => {
    const t = mask(e.target.value);
    setText(t);
    if (!t) emit("");
    else { const iso = usToIso(t); if (iso) emit(iso); }
  };

  return (
    <div className="relative w-full min-w-0">
      <input
        type="text"
        inputMode="numeric"
        autoComplete="off"
        value={text}
        onChange={onType}
        placeholder={placeholder}
        className={`iks-input w-full min-w-0 px-3.5 py-2.5 pr-11 text-sm ${text.length === 10 && !usToIso(text) ? "!border-red-500/60" : ""}`}
        data-testid={testId}
      />
      <span className="absolute right-0 top-0 h-full w-11 flex items-center justify-center text-sky-400 pointer-events-none">
        <Calendar size={16} />
      </span>
      <input
        type="date"
        tabIndex={-1}
        aria-label="Pick a date"
        value={value || ""}
        onChange={(e) => { setText(fmtDate(e.target.value)); emit(e.target.value); }}
        className="absolute right-0 top-0 opacity-0 cursor-pointer"
        style={{ width: "2.75rem", height: "100%", minHeight: 0, padding: 0 }}
        data-testid={testId ? `${testId}-picker` : undefined}
      />
    </div>
  );
}
